import Link from "next/link"
import { componentShowInMenu, createSlug } from "../../../../PartnerPortalLayout"
import { useLayoutData } from "../../../../../../utils/contexts/LayoutContext"
import router from "next/router"
import { useState } from "react"

interface MenuListProps {
  mobile?: boolean
  closeMobilMenu?: () => void
}

const MenuList = ({
  mobile,
  closeMobilMenu
}: MenuListProps) => {
  const { partnerSiteFull } = useLayoutData()
  const { page } = router.query

  const [mobileSubmenuOpen, setMobilSubmenuOpen] = useState<string | null | undefined>()

  const handleToggleSubmenu = (id?: string) => {
    setMobilSubmenuOpen((prevSubmenuOpen) => {
      if (prevSubmenuOpen === id) return null
      if (prevSubmenuOpen !== id) return id
    })
  }

  return (
    <>
      {partnerSiteFull?.pages &&
        partnerSiteFull.pages.map((menuPage, i) => (
          <li 
            key={i}
            className={`${mobileSubmenuOpen === menuPage.id ? 'active' : ''} ${componentShowInMenu(menuPage.id, partnerSiteFull) ? mobile ? 'menu-item-has-children' : 'has-children has-children--multilevel-submenu' : ''} ${!mobile ? page ? page[0] === menuPage.urlName ? 'active' : '' : i == 0 ? 'active' : '' : ''}`}
            onClick={mobile ? componentShowInMenu(menuPage.id, partnerSiteFull) ? () => handleToggleSubmenu(menuPage.id) : () => closeMobilMenu && closeMobilMenu() : undefined}
          >
            <Link href={i == 0 ? '/' : menuPage.urlName ? '/' + menuPage.urlName : '/'}>
              <a>{menuPage.name}</a>
            </Link>
            {componentShowInMenu(menuPage.id, partnerSiteFull) ? (
              <>
                {mobile ? <span className={'menu-expand'}><i></i></span> : null}
                <ul className={mobile ? 'sub-menu' : 'submenu'}>
                {
                  partnerSiteFull?.components && menuPage.id && partnerSiteFull?.components[menuPage.id]?.map((component, i) => {
                    if (component.enabled && component.showInMenu) {
                      return <li key={i} onClick={() => closeMobilMenu && closeMobilMenu()} className={router.asPath.includes(`#${createSlug(component?.title)}`) ? 'active' : ''}><Link href={menuPage.urlName ? '/' + menuPage.urlName + `#${createSlug(component?.title)}` : '/'}>{component.title}</Link></li>
                    }
                  })
                }
              </ul>
              </>
            ) : null}
          </li>
        ))}
    </>
  )
}

export default MenuList